import { SIZE_FULL } from '@/lib/gridElements/size';

import { MediasWidget } from '@/components/pages/analyze/widget/MediasWidget';

export const mostRecentTweetsConfig = {
    title: 'chart.twitter.widget_most_recent_tweets',
    id: 'widget_most_recent_posts',
    size: SIZE_FULL,
    sortFields: ['created', 'engagement_rate', 'likes', 'retweets', 'replies', 'impressions'],
    type: 'widget',
    element: MediasWidget
};
